import * as types from '../types.js';

export default {

	html: `
		<style>
			#columns
			{
				display: grid;
				grid-template-columns: 1fr 1fr;
			}
			#columns label:nth-child(odd)
			{
				text-align: left;
			}
			#columns label:nth-child(even)
			{
				text-align: right;
			}
			#setup input
			{
				display: inline-block;
			}
			#setup #sort_column { width: 12rem; margin-right: var(--space-lg); }
			#setup #page_length { width: 4rem; text-align: right; }
		</style>
		<form id="setup" class="form">
			<div class="fsb">
				<span>
					<label>Ordenar por&nbsp;
						<select id="sort_column" name="sort_column" required>
						</select>
					</label>
				</span>
				<span>
					<label class="blk tar">
						Ordem Ascendente
						<input class="sort_order" type="radio" name="sort_order" value="0">
					</label>
					<label class="blk">
						Ordem Descendente
						<input class="sort_order" type="radio" name="sort_order" value="1">
					</label>
				</span>
			</div>
			<fieldset>
				<legend>Colunas Visíveis</legend>
				<div id="columns">
				</div>
			</fieldset>
			<div class="fsb">
				<label>
					Linhas&nbsp;por&nbsp;Página&nbsp;
					<input id="page_length" name="page_length" type="number" min="1" max="500" required>
				</label>
				<label>
					Preservar Filtro Atual
					<input id="keep_filter" name="keep_filter" type="checkbox" checked>
				</label>
			</div>
			<div class="mtm">
				<button class="bn_Escape button" title="Fechar sem alterações">Fechar</button>
				<button class="bn_Enter button" title="Aplicar nova configuração">Aplicar</button>
			</div>
		</form>
	`,

	form: 
	{
		selector: '#setup',
	},

	fields: [
		{ properties: { selector: '#sort_column' }, types: [types.select()] },
		{ properties: { selector: '.sort_order' }, types: [types.radio()] },
		{ properties: { selector: '.columns' }, types: [types.checklist()] },
		{ properties: { selector: '#page_length' }, types: [types.number()] },
		{ properties: { selector: '#keep_filter' }, types: [types.checkbox()] }
	]

}

